'use strict';

var protons = require('protons');

module.exports = protons("\n\nmessage PeerIdProto {\n  required bytes id = 1;\n  bytes pubKey = 2;\n  bytes privKey = 3;\n}\n\n");